import OncologyPreConfig from ".";
import BreadCrumbs from "Utils/Common/Breadcrumb";

const OncologyResultFileConfiguration = () => {
  return (
    <>
      <div className="d-flex flex-column flex-column-fluid">
        <div className="app-toolbar py-3 py-lg-6">
          <div className="container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
            <BreadCrumbs />
          </div>
        </div>
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div
            id="kt_app_content_container"
            className="app-container container-fluid"
          >
            <div className="mb-5 hover-scroll-x">
              <div className="card tab-content-card">
                <OncologyPreConfig />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OncologyResultFileConfiguration;
